import React from "react";
import { t } from "../../utils/i18n";

const SuccessDeleteActivityModal = ({ action, closeModal }) => {

  return (
    <div
      className="modal-delistoffers-alert-cont"
      aria-hidden="true"
      aria-labelledby="delistOffers"
    >
      <div>
        <h5 className="delistoffer-modal-title">
          <i className="fas fa-check-circle"></i>
          <span>{t("stores.activity.success_action", { action: action })}</span>
        </h5>

        <div className="delistoffer-modal-buttons-section">
          <button
            type="button"
            className="delistoffer-modal-tradeaction-proceedbtn"
            onClick={closeModal}
          >
            {t("stores.activity.okay")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessDeleteActivityModal;
